var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0203 10.0767L13.8757 12.9314L12.9323 13.8747L10.0777 11.0194C9.0155 11.8708 7.69434 12.334 6.33301 12.332C3.02101 12.332 0.333008 9.64403 0.333008 6.33203C0.333008 3.02003 3.02101 0.332031 6.33301 0.332031C9.64501 0.332031 12.333 3.02003 12.333 6.33203C12.3349 7.69337 11.8718 9.01452 11.0203 10.0767ZM9.68301 9.58203C10.5291 8.71196 11.0016 7.54565 10.9997 6.33203C10.9997 3.75336 8.91101 1.66536 6.33301 1.66536C3.75434 1.66536 1.66634 3.75336 1.66634 6.33203C1.66634 8.91003 3.75434 10.9987 6.33301 10.9987C7.54663 11.0006 8.71293 10.5281 9.58301 9.68203L9.68301 9.58203Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9d82d6d6.svg";
export { ForwardRef as ReactComponent };